import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'

export interface NotificationStatusOption {
  code: string | null
  name: string
}

interface NotificationStatusResponse {
  status: NotificationStatusOption[]
}

const fetchFilterNotificationStatus = async (): Promise<NotificationStatusOption[]> => {
  const response = await httpClientPrivate.get<NotificationStatusResponse>(
    `${config.restUrl}/v1/backoffice/crash-detection/notification-status`,
  )
  return response.data.status
}

const useFilterNotificationStatus = () => {
  const queryKey = ['useFilterNotificationStatus']
  const queryFn = async () => fetchFilterNotificationStatus()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchFilterNotificationStatus, useFilterNotificationStatus }
